import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ChatValidators } from 'src/app/core/validators/chat.validators';
import { User } from 'src/app/user/model/user';
import { ChatUserSelectionEdit } from './model/chat-user-selection';
import { ChatService } from 'src/app/core/service/chat.service';
import { sortBy } from 'lodash';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserService } from 'src/app/core/service/user.service';

@Component({
  standalone: false,
  selector: 'app-chat-user-selection',
  templateUrl: './chat-user-selection.component.html',
  styleUrls: ['./chat-user-selection.component.scss']
})
export class ChatUserSelectionComponent
{
  @Input() public isNew = false;
  @Input() public allUsers: [] = [];
  @Input() public createMode = '';

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<User[]> = new EventEmitter();

  public selectionForm: any;
  public dialogOpened = false;
  public selectionEdit: ChatUserSelectionEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private chatValidators: ChatValidators) { }

  public get users(): UntypedFormControl
  {
    return this.selectionForm.get('users');
  }

  public get spaceName(): UntypedFormControl
  {
    return this.selectionForm.get('spaceName');
  }

  public get spaceDescription(): UntypedFormControl
  {
    return this.selectionForm.get('spaceDescription');
  }

  @Input() public set userDialogOpened(value: boolean)
  {
    this.dialogOpened = value;
  }

  @Input() public set model(selectionEdit: ChatUserSelectionEdit)
  {
    this.initModel(selectionEdit);
  }

  public onSave(): void
  {
    const objectToPersist = this.selectionForm.value;
    objectToPersist.users = this.users.value.map((user: User) => user.id);
    this.save.emit(objectToPersist);
  }

  public close(): void
  {
    this.cancelling.emit();
  }

  /**
   * Check if user from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public itemDisabled = (itemArgs: { dataItem: any; index: number }): boolean =>
    (itemArgs.dataItem.id === this.authenticationService.currentUser.id);


  public isOnline = (id: number) => this.allUsers.find((x: any) => x.id === id && x.online);

  private initModel(chatUserSelection: ChatUserSelectionEdit)
  {
    if (chatUserSelection === undefined)
    {
      return;
    }

    this.selectionEdit = chatUserSelection;

    this.selectionForm = this.fb.group({
      chatId: chatUserSelection.chatId,
      spaceId: chatUserSelection.spaceId,
      users: [{ value: sortBy(chatUserSelection.users, ['name']), disabled: false }, Validators.required],
      spaceName: [
        { value: chatUserSelection.spaceName, disabled: false },
        {
          validators: this.createMode === 'SPACE' ? [Validators.required] : [],
          asyncValidators: []
        }
      ],
      spaceDescription: [{ value: chatUserSelection.spaceDescription, disabled: false }],
    });

    const nameAsyncValidators = [this.chatValidators.validateChatSpaceNameUnique.bind(this,
      this.chatService,
      this.selectionForm.get('spaceName'),
      this.selectionForm.get('spaceName').value)];

    if (this.createMode === 'SPACE')
    {
      this.spaceName.setAsyncValidators(nameAsyncValidators);
      this.spaceName.updateValueAndValidity();
    }

    this.userService.getAllOnlineUsers().subscribe({
      next: (onlineUsers: any) =>
      {
        this.allUsers.forEach((u: any) =>
        {
          u.online = onlineUsers.data.find(x => x.id === u.id) !== undefined;
        });
      }
    });
  }
}
